import * as React from "react";
import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";

type AddAgentHeaderProps = {
  onSave?: () => void;
  onSaveAndPublish?: () => void;
  isSaving?: boolean;
};

export function AddAgentHeader({
  onSave,
  onSaveAndPublish,
  isSaving = false,
}: AddAgentHeaderProps) {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div>
          <nav className="flex items-center space-x-2 text-sm text-gray-500 mb-2">
            <Link to="/agents" className="hover:text-gray-700">
              Agents
            </Link>
            <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
            <span className="text-gray-900 font-medium">Add New Agent</span>
          </nav>
          <h1 className="text-2xl font-bold text-gray-900">Add New Agent</h1>
        </div>
        <div className="flex items-center space-x-3">
          <button
            type="button"
            onClick={onSave}
            disabled={isSaving}
            className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-brand-yellow hover:bg-yellow-500 border border-brand-yellow shadow-sm transition-colors rounded-lg disabled:opacity-50 disabled:pointer-events-none disabled:cursor-not-allowed"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V2" />
            </svg>
            {isSaving ? "Đang lưu..." : "Save"}
          </button>
          <button
            type="button"
            onClick={onSaveAndPublish}
            disabled={isSaving}
            className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-brand-yellow hover:bg-yellow-500 border border-brand-yellow shadow-sm transition-colors rounded-lg disabled:opacity-50 disabled:pointer-events-none disabled:cursor-not-allowed"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
            </svg>
            {isSaving ? "Đang lưu..." : "Save & Publish"}
          </button>
        </div>
      </div>
    </header>
  );
}